import { atom, selector, DefaultValue } from "recoil"
import { PlayerProps } from "./types"

export const defaultState = {
  currentTime: 0,
  muted: false,
  paused: true,
  duration: 0,
  view: "",
  volume: 0.5,
  reset: "",
  isControlVolume: false,
  isOpenControlsMobile: true,
  isOpenControlDesktop: true,
  isEnabledToggleControlDesktop: false,
  isMNPLastTime: false,
  isEnabledAutoPlay: false,
  isEnabledToggleMobile: true
}

export const playerPropsAtom = atom<PlayerProps>({
  key: "playerPropsAtom",
  default: defaultState
})

export const canDragSceenAtom = atom<boolean>({
  key: "canDragSceenAtom",
  default: true
})

export const autoPlayMNPAtom = atom<boolean>({
  key: "autoPlayMNPAtom",
  default: true
})

export const playerPropsSelector = selector<PlayerProps>({
  key: "playerPropsSelector",
  get: ({ get }) => get(playerPropsAtom),
  set: ({ get, set, reset }, newPlayerProps) => {
    const { action } = newPlayerProps as PlayerProps
    if (action === "reset") {
      reset(playerPropsAtom)
    } else {
      set(playerPropsAtom, {
        ...get(playerPropsAtom),
        ...newPlayerProps
      })
    }
  }
})

export const currentTimeAtom = atom<number>({
  key: "currentTimeAtom",
  default: 0
})

export const currentTimeMNPAtom = atom<{
  currentTime: number
  lastStopCurrentTime: number
}>({
  key: "currentTimeMNPAtom",
  default: {
    currentTime: 0,
    lastStopCurrentTime: 0
  }
})

interface currentTimeProps {
  handleReturnData?: () => Promise<number>
  type?: "RESET" | "UPDATE"
  payload?: {
    currentTime: number
  }
}

interface currentTimeMNPProps {
  handleReturnData?: () => Promise<{
    currentTime: number
    lastStopCurrentTime: number
  }>
  type?: "RESET" | "UPDATE_CURRENT_TIME" | "SAVE_LAST_TIME"
  payload?: {
    currentTime: number
  }
}

export const currentTimeSelector = selector<currentTimeProps>({
  key: "currentTimeSelector",
  get: ({ get, getCallback }) => {
    const handleReturnData = getCallback(({ snapshot }) => async () => {
      const data = await snapshot.getPromise(currentTimeAtom)

      return data
    })
    return { handleReturnData }
  },
  set: ({ set, reset }, action) => {
    if (action instanceof DefaultValue) {
      return false
    } else {
      const { type, payload } = action as any
      if (type === "RESET") {
        reset(currentTimeAtom)
      } else {
        set(currentTimeAtom, payload.currentTime)
      }
    }
  }
})

export const currentTimeMNPSelector = selector<currentTimeMNPProps>({
  key: "currentTimeMNPSelector",
  get: ({ get, getCallback }) => {
    const handleReturnData = getCallback(({ snapshot }) => async () => {
      const data = await snapshot.getPromise(currentTimeMNPAtom)

      return data
    })
    return { handleReturnData }
  },
  set: ({ set, reset, get }, action) => {
    if (action instanceof DefaultValue) {
      return false
    } else {
      const { type, payload } = action as any
      if (type === "SAVE_LAST_TIME") {
        const currentTimeProps = get(currentTimeMNPAtom)
        const data = {
          currentTime: currentTimeProps.currentTime,
          lastStopCurrentTime: currentTimeProps.currentTime
        }
        set(currentTimeMNPAtom, data)
      }

      if (type === "UPDATE_CURRENT_TIME") {
        const currentTimeProps = get(currentTimeMNPAtom)
        const data = {
          currentTime: payload.currentTime,
          lastStopCurrentTime: currentTimeProps.lastStopCurrentTime
        }
        set(currentTimeMNPAtom, data)
      }
      if (type === "RESET") {
        reset(currentTimeMNPAtom)
      }
    }
  }
})

export const userSpecificiedMediaPlayerHeight = atom({
  key: "userSpecifiedMediaPlayerHeight",
  default: null
})

export const isPlayerVisibleAtom = atom<boolean>({
  key: "isPlayerVisibleAtom", 
  default: false
})
